import { Spectral } from '@stoplight/spectral-core'
import { Command } from 'commander'

import { output } from '@/helpers/std-out'
import { getFileOrUrl } from '@/domains/document/helpers'
import {
  defaultRuleset,
  loadRuleset,
  severityToLabel,
} from '@/domains/document/lint/helpers'
import as from 'ansis'

const spectral = new Spectral()

export function LintCommand() {
  const cmd = new Command('lint')

  cmd.description('Lint your OpenAPI file using spectral rules')
  cmd.argument('[file|url]', 'OpenAPI file path or url')
  cmd.option('-r, --rule <file|url>', 'Rule path or url')
  cmd.action(
    async (
      inputArgument: string,
      { rule: ruleArgument }: { rule?: string },
    ) => {
      if (!inputArgument) {
        return output
          .error()
          .title('Invalid argument')
          .message('Please provide a file path')
          .exit('error')
      }

      // load api and rule document
      const specification = await getFileOrUrl(inputArgument)
      const ruleFileContents = ruleArgument
        ? await getFileOrUrl(ruleArgument)
        : defaultRuleset

      const ruleset = await loadRuleset(ruleFileContents)
      spectral.setRuleset(ruleset)

      const spectralDiagnostics = await spectral.run(specification)

      const hasErrors =
        spectralDiagnostics.filter((d) => d.severity === 0).length !== 0

      if (!hasErrors) {
        output.info().message(as.green('✔ No issues found!')).print()
      } else {
        output.warn().line(as.red('✖ Issues found:')).print()
      }
      for (const diagnostic of spectralDiagnostics) {
        output
          .info()
          .line(`${as.yellow('Rule:')} ${as.bold(diagnostic.code)}`)
          .line(`${as.yellow('Message:')} ${diagnostic.message}`)
          .line(
            `${as.yellow('Severity:')} ${severityToLabel(diagnostic.severity)}`,
          )
          .line(
            `${as.yellow('Location:')} ${diagnostic.range.start.line}:${diagnostic.range.start.character} - ${diagnostic.range.end.line}:${diagnostic.range.end.character}`,
          )
          .line(as.gray('---'))
          .print()
      }

      if (hasErrors) {
        output.error().exit('error')
      }
    },
  )

  return cmd
}
